import React from "react";
import { Wrapper, SectionHeading, AnchorLink } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { UserCreateForm } from "../../components";
import { CreateUserPageStyled } from "./CreateUserPageStyled";
var CreateUserPage = function (props) {
    return (React.createElement(BaseLayout, null,
        React.createElement(CreateUserPageStyled, null,
            React.createElement(Wrapper, { className: "wrapper my-50" },
                React.createElement(AnchorLink, { to: "/admin/users" }, "< Back to User List"),
                React.createElement(SectionHeading, { className: "heading" }, "Create User"),
                React.createElement(UserCreateForm, null)))));
};
export default CreateUserPage;
//# sourceMappingURL=CreateUserPage.js.map